import { DatePipe } from '@angular/common';
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, from, Observable, of, Subject, throwError } from 'rxjs';
import { User, UserWithoutToken } from '../models/user.model';
import { environment } from 'src/environments/environment';
import { PersistedValueEnum } from '../models/persisted-value-enum';
import { Module } from '../models/module.model';
import { Role } from '../models/role.model';
import { Client } from '../models/client.model';
import { Airdirective } from '../models/airdirective.model';
import { Document } from '../models/document.model';
import { DocTypeCategory } from '../models/docTypeCategory.model';
import { DocType } from '../models/docType.model';
import { Aircraft } from '../models/aircraft.model';
import { AircraftSummary } from '../models/aircraftSummary.model';
import { Engine } from '../models/engine.model';
import { LandingGear } from '../models/landingGear.model';
import { APU } from '../models/apu.model';
import { AssetDocument } from '../models/assetdocument.model';
import { Avionic } from '../models/avionic.model';
import { EngineSummary } from '../models/engineSummary.model';
import { ApuSummary } from '../models/apuSummary.model';
import { LandingGearSummary } from '../models/landingGearSummary.model';
import { GalleyProv } from '../models/galleyProv.model';
import { Propeller } from '../models/propeller.model';
import { PropellerSummary } from '../models/propellerSummary.model';
import { AirAdStatusList } from '../models/airAdStatusList.model';
import { StatusListDocs } from '../models/statusListDocs.model';
import { catchError, switchMap, map } from 'rxjs/operators';
import { Permissions } from 'src/app/models/permissions.model';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
import { ModalController } from '@ionic/angular';
import { ViewTableRowDetailComponent } from '../components/view-table-row-detail/view-table-row-detail.component';
import { AbstractControl } from '@angular/forms';
import { parse } from 'date-fns';
import { ViewTableRequiredActionComponent } from '../components/view-table-required-action/view-table-required-action.component';
import { DocumentViewerComponent } from '../components/document-viewer/document-viewer.component';
import { ReportViewerComponent } from '../components/report-viewer/report-viewer.component';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public logPageFormStep = new BehaviorSubject(1);
  public maintenanceTaskAddEditModelHeightChangeUsingRepairCategory = new BehaviorSubject(false);
  public userFullName = new BehaviorSubject(
    localStorage.getItem(PersistedValueEnum.userFullName) || ''
  );

  public userName = new BehaviorSubject(
    localStorage.getItem(PersistedValueEnum.userName) || ''
  );

  public userId = new BehaviorSubject(
    localStorage.getItem(PersistedValueEnum.userId) || ''
  );

  public subDomain = new BehaviorSubject(
    localStorage.getItem(PersistedValueEnum.subDomain) || ''
  );

  public user = new BehaviorSubject<User | undefined>(localStorage.getItem(PersistedValueEnum.user)
    ? JSON.parse(localStorage.getItem(PersistedValueEnum.user))
    : undefined);

  public client = new BehaviorSubject<Client | undefined>(undefined);
  private showMenu = new BehaviorSubject<boolean>(false);
  showMenu$ = this.showMenu.asObservable();

  triggerLogin$ = new Subject<void>();

  triggerLoginEvent() {
    this.triggerLogin$.next();
  }


    apiBaseUrl:string = window.location.origin + '/API/index.php/'
  constructor(
    public http: HttpClient,
    private location: Location,
    private snackBar: MatSnackBar,
    private modalController: ModalController,
    private datePipe: DatePipe
  ) {
    // values to keep when user refreshes the page
    const storedUser = localStorage.getItem(PersistedValueEnum.user);
    try {
      if (storedUser !== undefined) {
        this.user.next(JSON.parse(storedUser));
      }
    } catch {
      //console.error(`failed to parse user details - ${storedUser}`);
    }

    const storedClient = localStorage.getItem(PersistedValueEnum.client);
    try {
      if (storedClient !== undefined) {
        this.client.next(JSON.parse(storedClient));
      }
    } catch {
      console.error(`failed to parse client details - ${storedClient}`);
    }

    this.userFullName.subscribe(value => {
      localStorage.setItem(PersistedValueEnum.userFullName, value);
    });

    this.userName.subscribe(value => {
      localStorage.setItem(PersistedValueEnum.userName, value);
    });

    this.userId.subscribe(value => {
      localStorage.setItem(PersistedValueEnum.userId, value);
    });

    this.subDomain.subscribe(value => {
      localStorage.setItem(PersistedValueEnum.subDomain, value);
    });

    this.user.subscribe(value => {
      localStorage.setItem(PersistedValueEnum.user, JSON.stringify(value));
    });

    this.client.subscribe(value => {
      localStorage.setItem(PersistedValueEnum.client, JSON.stringify(value));
    });
  }
  setApiCallFuncForMenu(visible: boolean) {
    this.showMenu.next(visible);
  }


  // Refresh Token API --------------------------------------------------------------------------------


  //Module API's ---------------------------------------------------------------------------------------

  getModules(data): Observable<Module[]> {
    let params = new HttpParams();
    params = params.append('roleId', data.roleId);
    params = params.append('clientID', data.clientID);
    params = params.append('page', data.page);

    return this.http.get(this.apiBaseUrl + 'module/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      // if (err.status === 401) {
      //   // Handle 401 Unauthorized error
      //   localStorage.removeItem('user');
      localStorage.setItem('userFullName', "");
      localStorage.setItem('userName', "");
      localStorage.setItem('0', "");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      localStorage.removeItem("last_activity");
      //   sessionStorage.clear();
      //   window.location.href = '/#/auth';
      //   window.location.reload();
      // }
      return throwError(err)
    })) as Observable<Module[]>;
  }

  //MPD DataBase API's
  getMpdByAssets(paramsData, assetId, assetTypeId, searchedObj?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', paramsData.page);
    params = params.append('limit', paramsData.limit);
    params = params.append('assetId', assetId);
    params = params.append('assetTypeId', assetTypeId);
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params = params.append('easaAdNum', searchedText);
      // params = params.append('supercededBy', searchedText);
      // params = params.append('supercedes', searchedText);
      // params = params.append('curTotalCycles', searchedText);
    }
    if(paramsData?.filter){
       params = params.append(paramsData?.filter?.name, paramsData?.filter?.value);
    }
    if(paramsData?.eventId){
       params = params.append('eventId', paramsData?.eventId);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'mpd/listDetail', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  //Repair Damage DataBase API's
  getRepairDamageByAssets(paramsData, assetId, assetTypeId, searchedObj?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', paramsData.page);
    params = params.append('limit', paramsData.limit);
    params = params.append('assetId', assetId);
    params = params.append('assetTypeId', assetTypeId);
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params = params.append('easaAdNum', searchedText);
      // params = params.append('supercededBy', searchedText);
      // params = params.append('supercedes', searchedText);
      // params = params.append('curTotalCycles', searchedText);
    }
    if(paramsData?.filter){
       params = params.append(paramsData?.filter?.name, paramsData?.filter?.value);
    }
    if(paramsData?.eventId){
       params = params.append('eventId', paramsData?.eventId);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'repair-damage/listDetail', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getSbModByAssets(paramsData, assetId, assetTypeId, searchedObj?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', paramsData.page);
    params = params.append('limit', paramsData.limit);
    params = params.append('assetId', assetId);
    params = params.append('assetTypeId', assetTypeId);
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params = params.append('easaAdNum', searchedText);
      // params = params.append('supercededBy', searchedText);
      // params = params.append('supercedes', searchedText);
      // params = params.append('curTotalCycles', searchedText);
    }
    if(paramsData?.filter){
       params = params.append(paramsData?.filter?.name, paramsData?.filter?.value);
    }
    if(paramsData?.eventId){
       params = params.append('eventId', paramsData?.eventId);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'sb-mod/listDetail', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  //Airworthiness DataBase API's
  getAirWorthinessDirectivesByAssets(paramsData, assetId, assetTypeId, searchedObj?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', paramsData.page);
    params = params.append('limit', paramsData.limit);
    params = params.append('assetId', assetId);
    params = params.append('assetTypeId', assetTypeId);
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params = params.append('easaAdNum', searchedText);
      // params = params.append('supercededBy', searchedText);
      // params = params.append('supercedes', searchedText);
      // params = params.append('curTotalCycles', searchedText);
    }
    if(paramsData?.filter){
       params = params.append(paramsData?.filter?.name, paramsData?.filter?.value);
    }
    if(paramsData?.eventId){
       params = params.append('eventId', paramsData?.eventId);
    }
     if(paramsData?.reviewStatus){
      params = params.append('reviewStatus', paramsData.reviewStatus);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'airworthiness-directive/listDetail', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getAssetsForecastingFilterTabulerData(data?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    if (data) {
      params = params.append('assetId', data.assetId);
      params = params.append('assetType', data.assetType);
      params = params.append('forecastCycles', data.forecastCycles);
      params = params.append('forecastHours', data.forecastHours);
      params = params.append('forecastDate', data.forecastDate);
      if (data?.clearanceCycles) {
        params = params.append('clearanceCycles', data.clearanceCycles);
      }
      if (data?.clearanceHours) {
        params = params.append('clearanceHours', data.clearanceHours);
      }
      if (data?.clearanceDate) {
        params = params.append('clearanceDate', data.clearanceDate);
      }
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'forecast/forecast', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getInstalledAReportPermissions(data?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    if (data) {
      params = params.append('category', data.category);
      params = params.append('route', data.route);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'permission/checkAccess', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getInstalledAssetsList(data?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    if (data) {
      params = params.append('assetId', data.assetId);
      params = params.append('assetType', data.assetType);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'asset-attachment-report/attachedAssetList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getMipDetail(data?: any, searchedText?: string): Observable<Airdirective[]> {
    let params = new HttpParams();
    if (data) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
      params = params.append('assetId', data.assetId);
    }
    params = params.append('sort', '-updatedAt');
    if (searchedText) {
      params = params.append('name', searchedText);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'mip/listDetail', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getMipHistory(data, searchedText?: string): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('MIPId', data.MIPId);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchedText) {
      params = params.append('date', searchedText);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'mip/listHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getVirtualTourList(data,searchedObj?:any): Observable<Airdirective[]> {
    let params = new HttpParams();
    if(data?.page && data?.limit){
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
    params = params.append('assetId', data?.assetId);
    params = params.append('assetTypeId', data?.assetTypeId);
    if(searchedObj?.value && searchedObj?.searchedText){
        params = params.append(searchedObj?.value, searchedObj?.searchedText);
        // params.append('totalCycles', searchedText);
        // params.append('totalTime', searchedText);
      }
    if(data?.filter){
       params = params.append(data?.filter?.name, data?.filter?.value);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'external-links/list', {
      params: params,headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getMpd(data,searchedObj?:any): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    if (data?.filter) {
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + (data?.filter ? 'mpd/getMPDList' : 'mpd/list'), {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }


  getMaintenanceId(): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('sort', '-updatedAt');

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'maintenance-type/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getRepairDemage(data, searchedText?: string): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchedText) {
      params = params.append('mappingNumber', searchedText);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'repair-damage/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }

  getSbMod(data, searchedObj?: any): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    if (data?.filter) {
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'sb-mod/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getAirDirectives(data, searchedObj?: any): Observable<Airdirective[]> {
    let params = new HttpParams();
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    params = params.append('sort', '-updatedAt');
    if (data?.type) {
      params = params.append('type', data.type);
    }

    if (data?.filter) {
      params = params.append(data?.filter?.name, data?.filter?.value);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + (data?.filter ? 'airworthiness-directive/getADList' : 'airworthiness-directive/list'), {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }

  addAirDirective(data): Observable<Airdirective | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'awdb/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective | string>;
  }

  updateAirDirective(data): Observable<Airdirective | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'awdb/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective | string>;
  }

  deleteAirDirective(data): Observable<Airdirective | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'awdb/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective | string>;
  }

  getAirDirectivesDoc(data): Observable<Document[]> {
    let params = new HttpParams();
    params = params.append('parentId', data.parentId);
    params = params.append('id', data.id);
    params = params.append('sort', '-updatedAt');

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'awdb/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Document[]>;
  }

  addAirDirectiveStatusDoc(data): Observable<Document | string> {
    let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'maintenance-docs/insert', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Document | string>;
  }
  addAirDirectiveDoc(data): Observable<Document | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'awdb/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Document | string>;
  }



  addAirDirectiveDocAsync(data: any, file: File): Observable<Document | string> {

    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'awdb/insertuploaddoc'
    const formData: FormData = new FormData();

    let client = JSON.parse(localStorage.getItem("client"))?.clientID
    formData.append('clientId', client);
    formData.append('file', file);

    formData.append('recordObj', JSON.stringify({ "recordObj": data }));

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('POST', endPoint, formData, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<Document | string>;
  }


  deleteAirDirectiveDoc(data): Observable<Document | string> {
    let payload: any = {
      "recordId": data.recordId,
      "parentId": data.parentId
    }

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'awdb/deletedoc', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Document | string>;
  }

  //Aicraft statusList API's ------------------------------------------------------------------------------------
  //AD ----------------------------------------------------------------------------------------------------------
  getAirMaintenanceDocsList(): Observable<any[]> {
    let params = new HttpParams();
    // params = params.append('recordID', data.recordID);
    // params = params.append('parentID', data.parentID);
    // params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'maintenance-docs/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getAirAD(data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('recordID', data.recordID);
    params = params.append('parentID', data.parentID);
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }

  addAirAD(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data.recordObj));
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any>;
  }

  updateAirAD(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data.recordObj));
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any>;
  }

  deleteAirAD(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('parentID', data.parentID);
    params = params.append('recordID', data.recordID);
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any>;
  }

  getAirWorthinessDirectiveStatusDoc(data): Observable<StatusListDocs[]> {
    let params = new HttpParams();

    // params = params.append('recordID', data.recordID);
    // params = params.append('statusListID', data.statusListID);
    if (data.complianceId) {
      params = params.append('complianceId', data.complianceId);
    }
    else {
      params = params.append('assetMaintenanceMappingId', data.assetMaintenanceMappingId);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'maintenance-docs/listByAssetMaintenance', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<StatusListDocs[]>;
  }


  addAirADDoc(data): Observable<StatusListDocs | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data.obj));
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<StatusListDocs | string>;
  }

  deleteAirWorthinessDirectiveStatusDoc(data): Observable<StatusListDocs | string> {
    let params = new HttpParams();
    params = params.append('wrecordId', data.recordID);
    // params = params.append('parentID', data.parentID);
    // params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'maintenance-docs/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<StatusListDocs | string>;
  }


  // User Assets Access
  deleteUserAssetsAccess(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'user-asset-access/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  updateUserAssetsAccess(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'user-asset-access/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateBulkUserAssetsAccess(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'user-asset-access/addRoles', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  addUserAssetsAccess(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'user-asset-access/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addBulkUserAssetsAccess(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'user-asset-access/addRoles', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  getAssetsForecastingExcelPDFData(data, exportType: string): Observable<any> {
    let params = new HttpParams()
      .set('assetId', data.assetId)
      .set('assetType', data.assetType.toString())

    if (data) {
      params = params.append('forecastCycles', data.forecastCycles);
      params = params.append('forecastHours', data.forecastHours);
      params = params.append('forecastDate', data.forecastDate);
      if (data?.clearanceCycles) {
        params = params.append('clearanceCycles', data.clearanceCycles);
      }
      if (data?.clearanceHours) {
        params = params.append('clearanceHours', data.clearanceHours);
      }
      if (data?.clearanceDate) {
        params = params.append('clearanceDate', data.clearanceDate);
      }
    }

    // ✅ Choose the correct endpoint
    const url =
      exportType === 'excel'
        ? `${this.apiBaseUrl}forecast/exportExcelForecast`
        : `${this.apiBaseUrl}forecast/exportPDFForecast`;

    // ✅ Add headers and return HTTP call
    this.updateAccesToken(); // Make sure this function actually updates the token if needed

    return this.http.get(url, {
      params,
      headers: {
        Authorization: localStorage.getItem('token')
          ? `Bearer ${localStorage.getItem('token')}`
          : ''
      },
      responseType: 'blob' // Important if you're expecting Excel or PDF
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<Blob>;

  }
  getAssetsLogsReportExcelPDFData(data, exportType: string): Observable<any> {
    let params = new HttpParams()
      .set('assetId', data.assetId)
      .set('assetTypeId', data.assetTypeId?.toString())

    if (data?.startDate) {
      params = params.set('start_date', data.startDate);
    }

    if (data?.endDate) {
      params = params.set('end_date', data.endDate);
    }


    // ✅ Choose the correct endpoint
    const url =
      exportType === 'excel'
        ? `${this.apiBaseUrl}asset-utilization-report/exportExcelReport`
        : `${this.apiBaseUrl}asset-utilization-report/utilizationListPdf`;

    // ✅ Add headers and return HTTP call
    this.updateAccesToken(); // Make sure this function actually updates the token if needed

    return this.http.get(url, {
      params,
      headers: {
        Authorization: localStorage.getItem('token')
          ? `Bearer ${localStorage.getItem('token')}`
          : ''
      },
      responseType: 'blob' // Important if you're expecting Excel or PDF
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
            if (err.error instanceof Blob) {
      return new Observable(observer => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            observer.error(errorJson); // <-- real backend message
          } catch {
            observer.error({ error: 'File download failed' });
          }
        };

        reader.readAsText(err.error);
      });
    }
        return throwError(err);
      })
    ) as Observable<Blob>;

  }
  getAssetsAttachementReportExcelPDFData(data, exportType: string): Observable<any> {
    let params = new HttpParams()
      .set('assetId', data.assetId)
      .set('assetTypeId', data.assetTypeId.toString())
      .set('attachmentTypes', JSON.stringify(data.attachmentTypes));

    if (data?.columns && Object.keys(data.columns).length > 0) {
      params = params.set('columns', JSON.stringify(data.columns));
    }

    if (data?.attachmentIds && Object.keys(data?.attachmentIds).length > 0) {
      params = params.set('attachmentIds', JSON.stringify(data.attachmentIds));
    }

    if (data?.filters && Object.keys(data.filters).length > 0) {
      params = params.set('filters', JSON.stringify(data.filters));
    }

    if (data?.componentColumns && Object.keys(data.componentColumns).length > 0) {
      params = params.set('componentColumns', JSON.stringify(data.componentColumns));
    }

    if (data?.components?.length > 0) {
      params = params.set('components', JSON.stringify(data.components));
    }

    // ✅ Choose the correct endpoint
    const url =
      exportType === 'excel'
        ? `${this.apiBaseUrl}asset-attachment-report/exportExcelReport`
        : `${this.apiBaseUrl}asset-attachment-report/attachmentListPdf`;

    // ✅ Add headers and return HTTP call
    this.updateAccesToken(); // Make sure this function actually updates the token if needed

    return this.http.get(url, {
      params,
      headers: {
        Authorization: localStorage.getItem('token')
          ? `Bearer ${localStorage.getItem('token')}`
          : ''
      },
      responseType: 'blob' // Important if you're expecting Excel or PDF
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
            if (err.error instanceof Blob) {
      return new Observable(observer => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            observer.error(errorJson); // <-- real backend message
          } catch {
            observer.error({ error: 'File download failed' });
          }
        };

        reader.readAsText(err.error);
      });
    }
        return throwError(err);
      })
    ) as Observable<Blob>;

  }
  getAssetsHistoryReportExcelPDFData(data, exportType: string): Observable<any> {
    let params = new HttpParams()
      .set('assetId', data.assetId)
      .set('assetTypeId', data.assetTypeId.toString())
      .set(data.taskTypes ? 'taskTypes' : 'historyTypes', data.taskTypes ? JSON.stringify(data.taskTypes) : JSON.stringify(data.historyTypes));

    if (data?.columns && Object.keys(data.columns).length > 0) {
      params = params.set('columns', JSON.stringify(data.columns));
    }

    if (data?.filters && Object.keys(data.filters).length > 0) {
      params = params.set('filters', JSON.stringify(data.filters));
    }

    // ✅ Choose the correct endpoint
    const url =
      exportType === 'excel'
        ? `${this.apiBaseUrl}asset-history-report/exportExcelReport`
        : `${this.apiBaseUrl}asset-history-report/historyListPdf`;

    // ✅ Add headers and return HTTP call
    this.updateAccesToken(); // Make sure this function actually updates the token if needed

    return this.http.get(url, {
      params,
      headers: {
        Authorization: localStorage.getItem('token')
          ? `Bearer ${localStorage.getItem('token')}`
          : ''
      },
      responseType: 'blob' // Important if you're expecting Excel or PDF
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
            if (err.error instanceof Blob) {
      return new Observable(observer => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            observer.error(errorJson); // <-- real backend message
          } catch {
            observer.error({ error: 'File download failed' });
          }
        };

        reader.readAsText(err.error);
      });
    }
        return throwError(err);
      })
    ) as Observable<Blob>;

  }
  getTasksAssetReportExcelPDFData(data, exportType: string): Observable<any> {
    console.log(data)
    let params = new HttpParams()
      .set('assetId', data.assetId)
      .set('assetTypeId', data.assetTypeId.toString())
      .set('taskTypes', JSON.stringify(data.taskTypes));

    if (data?.columns && Object.keys(data.columns).length > 0) {
      params = params.set('columns', JSON.stringify(data.columns));
    }

    if (data?.filters && Object.keys(data.filters).length > 0) {
      params = params.set('filters', JSON.stringify(data.filters));
    }

    // ✅ Choose the correct endpoint
    const url =
      exportType === 'excel'
        ? `${this.apiBaseUrl}asset-task-report/exportExcelReport`
        : `${this.apiBaseUrl}asset-task-report/taskListPdf`;

    // ✅ Add headers and return HTTP call
    this.updateAccesToken(); // Make sure this function actually updates the token if needed

    return this.http.get(url, {
      params,
      headers: {
        Authorization: localStorage.getItem('token')
          ? `Bearer ${localStorage.getItem('token')}`
          : ''
      },
      responseType: 'blob' // Important if you're expecting Excel or PDF
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
            if (err.error instanceof Blob) {
      return new Observable(observer => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            observer.error(errorJson); // <-- real backend message
          } catch {
            observer.error({ error: 'File download failed' });
          }
        };

        reader.readAsText(err.error);
      });
    }
        return throwError(err);
      })
    ) as Observable<Blob>;

  }
  getUserAssetsAccess(data, searchedText?: any): Observable<Role[]> {
    let params = new HttpParams();
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    params = params.append('sort', '-updatedAt');
    if (searchedText) {
      params.append('date', searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'user-asset-access/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Role[]>;
  }
  getUserAssignedAssetsAccessAssetsList(data?: any, searchedObj?: any): Observable<Role[]> {
    let params = new HttpParams();
    params = params.append('limit', '100000000');
    params = params.append('userId', data?.userId);
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'user-asset-access/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Role[]>;
  }
  getUserAssetsAccessAssetsList(): Observable<Role[]> {
    let params = new HttpParams();
    params = params.append('isRole', '1');
    params = params.append('limit', '1000');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'user-asset-access/listAsset', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Role[]>;
  }
  //Role API's --------------------------------------------------------------------------------------------------

  getRoles(data?: any): Observable<Role[]> {
    let params = new HttpParams();
    if (data) {
      params = params.append('wroles', data.wroles);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'role/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Role[]>;
  }

  //Permissions API's --------------------------------------------------------------------------------------------------

  getPermissions(): Observable<Permissions[]> {
    // let params = new HttpParams();
    // params = params.append('wroles', data.wroles);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'permission/listTable', {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Permissions[]>;
  }

  //Get Role by Id API's --------------------------------------------------------------------------------------------------

  getRoleById(id: number): Observable<Permissions[]> {
    let params = new HttpParams();
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'role/listRoleById', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Permissions[]>;
  }

  //Client API's ------------------------------------------------------------------------------------------------
  public getClient(data) {
    let params = new HttpParams();
    params = params.append('wclients', data);
    return this.http.get(this.apiBaseUrl + 'client/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    });
  }

  addClient(data): Observable<Client | string> {
    let params = new HttpParams();
    params = params.append('clientObj', JSON.stringify(data.client));
    //params = params.append('user', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'client/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Client | string>;
  }

  updateClient(data): Observable<Client | string> {
    let params = new HttpParams();
    params = params.append('clientObj', JSON.stringify(data.client));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'client/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Client | string>;
  }

  //User API's ----------------------------------------------------------------------------------------------------
  getNonAssignedUsersListToEvent(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('eventId', data.eventId);
    if(data?.filter){
      if(data?.filter?.name === 'filter'){
        params = params.set(data?.filter?.name?.toString(), data?.filter?.value);
      }else{
         params = params.set(data?.filter?.name?.toString(), JSON.stringify(data?.filter?.value));
      }
    }

    params = params.set('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/unassignedUsers', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }
  getUser(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('clientID', data.clientID);
    if(data?.filter){
      if(data?.filter?.name === 'filter'){
        params = params.set(data?.filter?.name?.toString(), data?.filter?.value);
      }else{
         params = params.set(data?.filter?.name?.toString(), JSON.stringify(data?.filter?.value));
      }
    }

    params = params.set('sort', '-id');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'user/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }
  getOilEventThreads(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('itemId', data.itemId);

    this.updateAccesToken()

    return this.http.get(this.apiBaseUrl + 'oil-comment/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }

  getOilEventItemAttachment(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('itemId', data?.itemId);


    params = params.set('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-attachment/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }
  //Reove this function
  getoilEventComment(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('itemId', data?.itemId);


    params = params.set('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-comment/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }

  getOilEventItemActivityLogs(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('itemId', data?.itemId);


    params = params.set('sort', '-updated_at');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-item/activityLog', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }

  getOilEventItemListThread(data): Observable<User[]> {
    let params = new HttpParams();
    // params = params.set('userId', data.userId);
    params = params.set('itemId', data?.itemId);


    params = params.set('sort', '-updated_at');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-comment/listThread', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User[]>;
  }

  markOilEventItemCommentAsSeen(data): Observable<User | string> {
    let params = new HttpParams();
    // params = params.append('userObj', JSON.stringify(data.user));
    // params = params.append('commentId',  data.commentId);

    const formData = new FormData();
    formData.append('commentId', data.commentId);

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-comment/markCommentSeen', formData, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User | string>;
  }

  addUser(data): Observable<User | string> {
    let params = new HttpParams();
    // params = params.append('userObj', JSON.stringify(data.user));
    // params = params.append('userObjRP', data.randomPass);

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'user/insert', { recordObj: data.user }, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User | string>;
  }

  updateUser(data): Observable<User | string> {
    let params = new HttpParams();
    // params = params.append('userObj', JSON.stringify(data.user));
    // params = params.append('userObjRP', data.pass);
    // params = params.append('wtd', data.wtd);

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'user/update', { recordObj: data.user }, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User | string>;
  }

  deleteUser(data): Observable<User | string> {
    let params = new HttpParams();
    params = params.append('id', data.userId);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'user/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<User | string>;
  }

  authenticateUser(data): Observable<UserWithoutToken> {
    let params = new HttpParams();
    params = params.append('userName', data.userName);
    params = params.append('clientID', data.clientID);
    params = params.append('password', data.password);

    return this.http.get(this.apiBaseUrl + 'user/auth', {
      params: params
    }) as Observable<User>;
  }

  authenticateLoginUser(data): Observable<HttpResponse<UserWithoutToken>> {
    let params = new HttpParams()
      .set('userName', data.userName)
      .set('clientID', data.clientID)
      .set('password', data.password);

    return this.http.post<UserWithoutToken>(
      this.apiBaseUrl + 'user/auth',
      null,
      {
        params,
        observe: 'response'
      }
    );
  }

  /**
   * @deprecated use forgotPassword instead
   */
  newPasswordRequest(data): Observable<string> {
    let params = new HttpParams();
    params = params.append('email', data.email);
    params = params.append('clientID', data.clientID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'user/passreset', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<string>;
  }

  forgotPassword(data: {
    clientID: number;
    email: string;
  }): Observable<number> {
    let params = new HttpParams();
    params = params.append('email', data.email);
    params = params.append('clientID', data.clientID);
    return this.http.get<number>(this.apiBaseUrl + 'user/generatePassResetToken', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    });
  }

  resetPassword(data): Observable<string[]> {
    return this.http.post<string[]>(this.apiBaseUrl + 'user/passReset', data);
  }

  verifyOTP(data: {
    userId: string;
    clientID: string;
    otp: number;
  }): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.apiBaseUrl + 'user/verifyOTP', data, { observe: 'response' });
  }


  resendOtp(data: {
    userName: string;
  }): Observable<HttpResponse<User>> {
    return this.http.post<User>(this.apiBaseUrl + 'user/resendOTP', data, { observe: 'response' });
  }

  isLoggedIn() {
    try {
      const token = localStorage.getItem("token") || null
      return token
    }
    catch {
      return false;
    }
  }
  loggedInCheck() {
    try {
      const token = localStorage.getItem("token") || null
      return !token ? true : false
    }
    catch {
      return false;
    }
  }

  //Aircraft API's ----------------------------------------------------------------------------------------------------

  insertAircraft(data): Observable<Aircraft | number> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft | number>;
  }

  updateAircraft(data): Observable<Aircraft> {

    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft>;
  }

  updateAircraftDoc(data): Observable<Aircraft> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'aircraft/updatedoc', {
      recordObj: data
    }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft>;
  }

  deleteAircraft(data): Observable<Aircraft | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft | string>;
  }

  getAssetAttachedAssets(data): Observable<Aircraft[]> {
    let params = new HttpParams();
    if (data?.assetId && data.assetTypeId) {
      params = params.append('assetId', data.assetId);
      params = params.append('assetTypeId', data.assetTypeId);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/getAssetAttachedAssets', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft[]>;
  }
  getAircraftByClientId(data): Observable<Aircraft[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
    if (data?.recordId) {
      params = params.append('id', data.recordId);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft[]>;
  }

  getEventUsersListByEventId(eventId:any): Observable<Aircraft> {
    let params = new HttpParams();
    // params = params.append('clientID', data.clientId);
    params = params.append('eventId', eventId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/assignedUsers', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft>;
  }
  getEventItemDashboardData(args:any): Observable<Aircraft> {
    let params = new HttpParams();
    // params = params.append('clientID', data.clientId);
    params = params.append('eventId', args.eventId);
    if(args?.assetId && args?.assetTypeId){
       params = params.append('assetId', args.assetId);
        params = params.append('assetTypeId', args.assetTypeId);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/OILEventDashboard', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft>;
  }
  getEventById(eventId:any,searchedObj?: any): Observable<Aircraft> {
    let params = new HttpParams();
    // params = params.append('clientID', data.clientId);
    params = params.append('eventId', eventId);
     if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/items', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft>;
  }
  getAircraftById(data): Observable<Aircraft> {
    let params = new HttpParams();
    // params = params.append('clientID', data.clientId);
    params = params.append('id', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Aircraft>;
  }

  insertAircraftSummary(data, aircraftObj): Observable<AircraftSummary> {
    let payload: any = {
      recordObj: data,
      aircraftObj: aircraftObj
    }

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'aircraft/insertSummary', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AircraftSummary>;
  }

  getAircraftSummaryByAicraftId(data): Observable<AircraftSummary[]> {
    let params = new HttpParams();
    params = params.append('wit', data.wit);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/listsummary', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AircraftSummary[]>;
  }
  viewSpecificationReport(assetId,assetTypeId): Observable<AircraftSummary[]> {
    let params = new HttpParams();
    params = params.append('assetId', assetId);
    params = params.append('assetTypeId', assetTypeId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'report/show', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AircraftSummary[]>;
  }
  viewReportById(id): Observable<AircraftSummary[]> {
    let params = new HttpParams();
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'report/view', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AircraftSummary[]>;
  }

  generateReport(obj): Observable<Propeller> {
    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'report/insert', obj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  getSummaryReport(data): Observable<AircraftSummary[]> {
    let params = new HttpParams();
    params = params.append('assetTypeId', data.assetTypeId);
    params = params.append('assetId', data.assetId);
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'report/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AircraftSummary[]>;
  }

  deleteAircraftSummary(data): Observable<AircraftSummary | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'aircraft/deleteSummary', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AircraftSummary | string>;
  }
  getDocumentsByAssetTypeId(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetTypeId', data.assetTypeId);
    params = params.append('assetId', data.assetId);
    if(data?.sectionType){
      params = params.append('section', data?.sectionType);
    }
    if(data?.filenameFilter){
      params = params.append('filenameFilter', data.filenameFilter);
    }
    if(data?.folderNodeId){
      params = params.append('folderNodeId', JSON.stringify(data.folderNodeId));
    }
    console.log(params)

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'asset-doc/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

    getEventDocumentsByEventId(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('eventId', data.eventId);
    if(data?.folderNodeId?.length > 0){
      params = params.append('folderNodeId', JSON.stringify(data.folderNodeId));
    }
    if(data?.reviewStatus){
      params = params.append('reviewStatus', data.reviewStatus);
    }
    if(data?.assetId && data?.assetTypeId){
      params = params.append('assetId', data.assetId);
      params = params.append('assetTypeId', data.assetTypeId);
    }
    console.log(params)

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'asset-doc/listForOIL', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getAircraftDocumentsByAssetSN(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('recordID', data.recordId);
    params = params.append('assetId', data.assetId);
    if (data.filenameFilter) {
      params = params.append('filenameFilter', data.filenameFilter);
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getAircraftDocumentsById(data): Observable<AssetDocument> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument>;
  }

  addAircraftDoc(data): Observable<AssetDocument | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }

  getPresignedUrl(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}aircraft/getUploadUrlDoc`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }
    const formData = new FormData();
    formData.append('clientId', clientID);
    formData.append('recordObj', JSON.stringify({ recordObj: data }));

    // const payload: any = {
    //   clientId: clientID,
    //   recordObj: data
    // };

    return this.http.post(endPoint, formData, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  addAircraftDocBulkUploadAsync(data: any, presignedUrl: string, file: File): Observable<any> {
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }

    console.log('Presigned URL:', presignedUrl);

    // First API call: Upload file to the presigned URL
    const uploadFileToPresignedUrl = from(fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    })).pipe(
      catchError(error => {
        console.error('File upload failed:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );

    data['uploadedFileUrl'] = presignedUrl.split('?')[0];

    // Second API call: Insert metadata to the backend
    const insertMetadataToBackend = (data: any): Observable<any> => {
      const endPoint = `${this.apiBaseUrl}aircraft/insertuploaddoc`;
      const formData = new FormData();
      formData.append('clientId', clientID);
      formData.append('recordObj', JSON.stringify({ recordObj: data }));

      console.log('Endpoint:', endPoint);

      return this.http.post(endPoint, formData, {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
        },
      }).pipe(
        catchError(err => {
          if (err.status === 401) {
            // Handle 401 Unauthorized error
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', "");
            localStorage.setItem('userName', "");
            localStorage.setItem('0', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('last_activity');
            sessionStorage.clear();
            window.location.href = '/#/auth';
            window.location.reload();
          }
          return throwError(err);
        })
      );
    };

    // Chain the API calls
    return uploadFileToPresignedUrl.pipe(
      switchMap(() => insertMetadataToBackend(data)),
      catchError(error => {
        console.error('Error during the process:', error);
        return throwError(() => new Error('An error occurred during the file upload process'));
      })
    );
  }




  deleteDoc(data): Observable<AssetDocument | string> {

    let payload: any = {
      "recordId": data.recordId,
      "parentId": data.parentId
    }
    let params = new HttpParams();
    if(data?.section){
      params = params.append('section', data?.section);
    }

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'asset-doc/delete', payload, {
     params:params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }
  getAvionicList(data): Observable<Avionic[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.assetId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/listavionic', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Avionic[]>;
  }

  insertAvionicComponent(data): Observable<Avionic> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/insertavionic', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Avionic>;
  }
  updateAvionicComponent(data): Observable<Avionic> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/updateavionic', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Avionic>;
  }

  deleteAssetsReport(data): Observable<Avionic | string> {
    let params = new HttpParams();
    params = params.append('id', data.id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'report/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Avionic | string>;
  }
  deleteAvionicComponent(data): Observable<Avionic | string> {
    let params = new HttpParams();
    params = params.append('recordId', data.recordId);
    params = params.append('parentId', data.parentId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/deleteavionic', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Avionic | string>;
  }

  getGalleyProvList(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('assetSN', data.assetId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/listGalley', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any>;
  }

  insertGalleyProvComponent(data): Observable<GalleyProv> {
    // let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));
    let payload: any = {
      "recordObj": data,
    }

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'aircraft/insertGalley', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<GalleyProv>;
  }
  updateGalleyProvComponent(data): Observable<GalleyProv> {
    // let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));
    let payload: any = {
      "recordObj": data,
    }

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'aircraft/updateGalley', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<GalleyProv>;
  }

  deleteGalleyProvComponent(data): Observable<GalleyProv | string> {
    let params = new HttpParams();
    params = params.append('recordId', data.recordId);
    params = params.append('parentId', data.parentId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/deleteGalley', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<GalleyProv | string>;
  }

  //Engine API's ------------------------------------------------------------------------------------------------------

  insertEngine(data): Observable<Engine | number> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine | number>;
  }



  updateEngine(data, wtd?: string): Observable<Engine> {
    let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));
    if (wtd) {
      params = params.append('wtd', wtd);
      params = params.append('recordObj', JSON.stringify({ aerEngId: data?.aerEngId }));
    }
    else {
      params = params.append('recordObj', JSON.stringify(data));
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine>;
  }



  updateEngineDoc(data): Observable<Engine> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'engine/updatedoc', {
      recordObj: data
    }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine>;
  }

  deleteEngine(data): Observable<Engine | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine | string>;
  }

  getAirADDoc(data): Observable<StatusListDocs[]> {
    let params = new HttpParams();
    params = params.append('parentID', data.parentID);
    params = params.append('recordID', data.recordID);
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<StatusListDocs[]>;
  }

  deleteAirADDoc(data): Observable<StatusListDocs | string> {
    let params = new HttpParams();
    params = params.append('recordID', data.recordID);
    params = params.append('parentID', data.parentID);
    params = params.append('statusListID', data.statusListID);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraftstatuslist/deletedoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<StatusListDocs | string>;
  }

  getSearchedAircraft(data): Observable<Engine[]> {
    let params = new HttpParams();
    if(data?.page && data.limit){
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
     if(data?.filter){
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    if(!data?.is_installed){
      params = params.append('is_installed', data.is_installed);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'aircraft/getAircraftList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getUninstalledEngine(data): Observable<Engine[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
     if(data?.filter){
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    if(!data?.is_installed){
      params = params.append('is_installed', data.is_installed);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/getEngineList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getUninstalledApu(data): Observable<Engine[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
     if(data?.filter){
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    if(data?.searchedAssets){
      params = params.append(data?.searchedAssets?.name, data?.searchedAssets?.value);
    }
    if(!data?.is_installed){
      params = params.append('is_installed', data.is_installed);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/getApuList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getUninstalledLandingGear(data): Observable<Engine[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
    if(data?.filter){
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    if(!data?.is_installed){
      params = params.append('is_installed', data.is_installed);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/getLandingGearList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getUninstalledPropeller(data): Observable<Engine[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
     if(data?.filter){
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    if(!data?.is_installed){
      params = params.append('is_installed', data.is_installed);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/getPropellerList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getUninstalledComponent(data): Observable<Engine[]> {
    let params = new HttpParams();
    if (data?.page && data?.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
     if(data?.filter){
      params = params.append(data?.filter?.name, data?.filter?.value);
    }
    if(!data?.is_installed){
      params = params.append('is_installed', data.is_installed);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'component/getComponentList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getEngineByClientId(data): Observable<Engine[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
    if (data?.recordId) {
      params = params.append('recordID', data.recordId);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine[]>;
  }
  getEngineHistoryByEngineId(data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('engine_id', data.engine_id);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/listHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getApuHistoryByEngineId(data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('apu_id', data.apu_id);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/listHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }

  getLandingGearHistoryByEngineId(data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('landing_gear_id', data.landing_gear_id);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/listHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getPropellerHistoryByEngineId(data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('propeller_id', data.propeller_id);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/listHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }

  getEngineById(data): Observable<Engine> {
    let params = new HttpParams();
    // params = params.append('clientID', data.clientId);
    params = params.append('id', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Engine>;
  }

  insertEngineSummary(data): Observable<EngineSummary> {
    // let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'engine/insertSummary', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<EngineSummary>;
  }

  getEngineSummaryByEngineId(data): Observable<EngineSummary[]> {
    let params = new HttpParams();
    params = params.append('wit', data.wit);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/listsummary', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<EngineSummary[]>;
  }

  getEngineDocumentsByAssetSN(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('assetId', data.assetId);
    params = params.append('recordID', data.recordId);
    if (data.filenameFilter) {
      params = params.append('filenameFilter', data.filenameFilter);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getEngineDocumentsById(data): Observable<AssetDocument> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument>;
  }

  addEngineDoc(data): Observable<AssetDocument | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'engine/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }

  getEnginePresignedUrl(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}engine/getUploadUrlDoc`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }
    const formData = new FormData();
    formData.append('clientId', clientID);
    formData.append('recordObj', JSON.stringify({ recordObj: data }));

    // const payload: any = {
    //   clientId: clientID,
    //   recordObj: data
    // };

    return this.http.post(endPoint, formData, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  addEngineDocAsync(data: any, presignedUrl: string, file: File): Observable<AssetDocument | string> {

    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }

    console.log('Presigned URL:', presignedUrl);

    // First API call: Upload file to the presigned URL
    const uploadFileToPresignedUrl = from(fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    })).pipe(
      catchError(error => {
        console.error('File upload failed:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );

    data['uploadedFileUrl'] = presignedUrl.split('?')[0];

    // Second API call: Insert metadata to the backend
    const insertMetadataToBackend = (data: any): Observable<any> => {
      const endPoint = `${this.apiBaseUrl}engine/insertuploaddoc`;
      const formData = new FormData();
      formData.append('clientId', clientID);
      formData.append('recordObj', JSON.stringify({ recordObj: data }));

      console.log('Endpoint:', endPoint);

      return this.http.post(endPoint, formData, {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
        },
      }).pipe(
        catchError(err => {
          if (err.status === 401) {
            // Handle 401 Unauthorized error
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', "");
            localStorage.setItem('userName', "");
            localStorage.setItem('0', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('last_activity');
            sessionStorage.clear();
            window.location.href = '/#/auth';
            window.location.reload();
          }
          return throwError(err);
        })
      );
    }
    return uploadFileToPresignedUrl.pipe(
      switchMap(() => insertMetadataToBackend(data)),
      catchError(error => {
        console.error('Error during the process:', error);
        return throwError(() => new Error('An error occurred during the file upload process'));
      })
    );
  }

  //APU API's ----------------------------------------------------------------------------------------------------

  insertApu(data): Observable<APU | number> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<APU | number>;
  }

  updateApu(data, wtd?: string): Observable<APU> {
    let params = new HttpParams();
    if (wtd) {
      params = params.append('wtd', wtd);
      params = params.append('recordObj', JSON.stringify({ aerApuId: data?.aerApuId }));
    }
    else {
      params = params.append('recordObj', JSON.stringify(data));
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<APU>;
  }


  updateApuDoc(data): Observable<APU> {
    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'apu/updatedoc', {
      recordObj: data
    }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<APU>;
  }

  deleteAPU(data): Observable<APU | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<APU | string>;
  }
  getApuByClientId(data): Observable<APU[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }

    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<APU[]>;
  }

  getApuById(data): Observable<APU> {
    let params = new HttpParams();
    // params = params.append('clientID', data.clientId);
    params = params.append('id', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<APU>;
  }

  insertApuSummary(data): Observable<ApuSummary> {
    // let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'apu/insertSummary', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<ApuSummary>;
  }

  getApuSummaryByApuId(data): Observable<ApuSummary[]> {
    let params = new HttpParams();
    params = params.append('wit', data.wit);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/listsummary', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<ApuSummary[]>;
  }

  getApuDocumentsByAssetSN(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('assetId', data.assetId);
    params = params.append('recordID', data.recordId);
    if (data.filenameFilter) {
      params = params.append('filenameFilter', data.filenameFilter);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getApuDocumentsById(data): Observable<AssetDocument> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument>;
  }

  addApuDoc(data): Observable<AssetDocument | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'apu/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }

  getApuPresignedUrl(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}apu/getUploadUrlDoc`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }
    const formData = new FormData();
    formData.append('clientId', clientID);
    formData.append('recordObj', JSON.stringify({ recordObj: data }));

    // const payload: any = {
    //   clientId: clientID,
    //   recordObj: data
    // };

    return this.http.post(endPoint, formData, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  addApuDocAsync(data: any, presignedUrl: string, file: File): Observable<AssetDocument | string> {
    this.updateAccesToken()
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }

    console.log('Presigned URL:', presignedUrl);

    // First API call: Upload file to the presigned URL
    const uploadFileToPresignedUrl = from(fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    })).pipe(
      catchError(error => {
        console.error('File upload failed:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );

    data['uploadedFileUrl'] = presignedUrl.split('?')[0];

    // Second API call: Insert metadata to the backend
    const insertMetadataToBackend = (data: any): Observable<any> => {
      const endPoint = `${this.apiBaseUrl}apu/insertuploaddoc`;
      const formData = new FormData();
      formData.append('clientId', clientID);
      formData.append('recordObj', JSON.stringify({ recordObj: data }));

      console.log('Endpoint:', endPoint);

      return this.http.post(endPoint, formData, {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
        },
      }).pipe(
        catchError(err => {
          if (err.status === 401) {
            // Handle 401 Unauthorized error
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', "");
            localStorage.setItem('userName', "");
            localStorage.setItem('0', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('last_activity');
            sessionStorage.clear();
            window.location.href = '/#/auth';
            window.location.reload();
          }
          return throwError(err);
        })
      );
    }
    return uploadFileToPresignedUrl.pipe(
      switchMap(() => insertMetadataToBackend(data)),
      catchError(error => {
        console.error('Error during the process:', error);
        return throwError(() => new Error('An error occurred during the file upload process'));
      })
    );
  }

  //Landing Gear API's ------------------------------------------------------------------------------------------------------
  insertLGear(data): Observable<LandingGear | number> {
    let params = new HttpParams();
    data["tgtAsOfDate"] = data["tgtAsOfDate"] ? data["tgtAsOfDate"].split("T")[0] : null
    data["manufactureDate"] = data["manufactureDate"] ? data["manufactureDate"].split("T")[0] : null
    console.log({ data })
    params = params.append('recordObj', JSON.stringify(data));


    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGear | number>;
  }

  updateLGear(data, wtd?: string): Observable<LandingGear> {
    let params = new HttpParams();
    // console.log({ data })
    if (wtd) {
      params = params.append('wtd', wtd);
      params = params.append('recordObj', JSON.stringify({ aerLgId: data?.aerLgId }));
    }
    else {
      params = params.append('recordObj', JSON.stringify(data));
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGear>;
  }


  updateLGearDoc(data): Observable<LandingGear> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'landinggear/updatedoc', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGear>;
  }

  deleteLGear(data): Observable<LandingGear | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGear | string>;
  }

  getLandingGearByClientId(data): Observable<LandingGear[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }

    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGear[]>;
  }

  getLandingGearById(data): Observable<LandingGear> {
    let params = new HttpParams();
    params = params.append('id', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGear>;
  }

  insertLGearSummary(data): Observable<LandingGearSummary> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'landinggear/insertSummary', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGearSummary>;
  }

  getLGearSummaryByLGId(data): Observable<LandingGearSummary[]> {
    let params = new HttpParams();
    params = params.append('wit', data.wit);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/listsummary', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<LandingGearSummary[]>;
  }


  getLandingGearDocumentsByAssetSN(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('assetId', data.assetId);
    params = params.append('recordID', data.recordId);
    if (data.filenameFilter) {
      params = params.append('filenameFilter', data.filenameFilter);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getLandingGearDocumentsById(data): Observable<AssetDocument> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument>;
  }

  addLandingGearDoc(data): Observable<AssetDocument | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'landinggear/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }

  getLandingGearPresignedUrl(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}landinggear/getUploadUrlDoc`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }
    const formData = new FormData();
    formData.append('clientId', clientID);
    formData.append('recordObj', JSON.stringify({ recordObj: data }));

    // const payload: any = {
    //   clientId: clientID,
    //   recordObj: data
    // };

    return this.http.post(endPoint, formData, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  addLandingGearDocAsync(data: any, presignedUrl: string, file: File): Observable<AssetDocument | string> {
    this.updateAccesToken()
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }

    console.log('Presigned URL:', presignedUrl);

    // First API call: Upload file to the presigned URL
    const uploadFileToPresignedUrl = from(fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    })).pipe(
      catchError(error => {
        console.error('File upload failed:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );

    data['uploadedFileUrl'] = presignedUrl.split('?')[0];

    // Second API call: Insert metadata to the backend
    const insertMetadataToBackend = (data: any): Observable<any> => {
      const endPoint = `${this.apiBaseUrl}landinggear/insertuploaddoc`;
      const formData = new FormData();
      formData.append('clientId', clientID);
      formData.append('recordObj', JSON.stringify({ recordObj: data }));

      console.log('Endpoint:', endPoint);

      return this.http.post(endPoint, formData, {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
        },
      }).pipe(
        catchError(err => {
          if (err.status === 401) {
            // Handle 401 Unauthorized error
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', "");
            localStorage.setItem('userName', "");
            localStorage.setItem('0', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('last_activity');
            sessionStorage.clear();
            window.location.href = '/#/auth';
            window.location.reload();
          }
          return throwError(err);
        })
      );
    }
    return uploadFileToPresignedUrl.pipe(
      switchMap(() => insertMetadataToBackend(data)),
      catchError(error => {
        console.error('Error during the process:', error);
        return throwError(() => new Error('An error occurred during the file upload process'));
      })
    );
  }

  //Propeller API's ------------------------------------------------------------------------------------------------------
  insertProp(data): Observable<Propeller | number> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/insert', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller | number>;
  }

  updateProp(data, wtd?: string): Observable<Propeller> {
    let params = new HttpParams();
    if (wtd) {
      params = params.append('wtd', wtd);
      params = params.append('recordObj', JSON.stringify({ aerPropId: data?.aerPropId }));
    }
    else {
      params = params.append('recordObj', JSON.stringify(data));
    }

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/update', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  updatePropDoc(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'propeller/updatedoc', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  deleteProp(data): Observable<Propeller | string> {
    let params = new HttpParams();
    params = params.append('recordId', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller | string>;
  }

  clearAllMSNProp(data): Observable<Propeller> {
    let params = new HttpParams();
    params = params.append('recordObj', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/updateAll', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  getPropByClientId(data): Observable<Propeller[]> {
    let params = new HttpParams();
    if (data?.page && data.limit) {
      params = params.append('page', data.page);
      params = params.append('limit', data.limit);
    }
    params = params.append('sort', '-updatedAt');

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller[]>;
  }

  getPropById(data): Observable<Propeller> {
    let params = new HttpParams();
    params = params.append('id', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  insertPropSummary(data): Observable<PropellerSummary> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'propeller/insertSummary', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<PropellerSummary>;
  }

  getPropSummaryByPropId(data): Observable<PropellerSummary[]> {
    let params = new HttpParams();
    params = params.append('wit', data.wit);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/listsummary', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<PropellerSummary[]>;
  }

  getPropDocumentsByAssetSN(data): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('assetId', data.assetId);
    params = params.append('recordID', data.recordId);
    if (data.filenameFilter) {
      params = params.append('filenameFilter', data.filenameFilter);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getPropDocumentsById(data): Observable<AssetDocument> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('recordID', data.recordId);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument>;
  }

  addPropDoc(data): Observable<AssetDocument | string> {
    let params = new HttpParams();
    params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'propeller/insertdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }

  getPropellerPresignedUrl(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}propeller/getUploadUrlDoc`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }
    const formData = new FormData();
    formData.append('clientId', clientID);
    formData.append('recordObj', JSON.stringify({ recordObj: data }));

    // const payload: any = {
    //   clientId: clientID,
    //   recordObj: data
    // };

    return this.http.post(endPoint, formData, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  addPropDocAsync(data: any, presignedUrl: string, file: File): Observable<AssetDocument | string> {
    this.updateAccesToken()
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }

    console.log('Presigned URL:', presignedUrl);

    // First API call: Upload file to the presigned URL
    const uploadFileToPresignedUrl = from(fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    })).pipe(
      catchError(error => {
        console.error('File upload failed:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );

    data['uploadedFileUrl'] = presignedUrl.split('?')[0];

    // Second API call: Insert metadata to the backend
    const insertMetadataToBackend = (data: any): Observable<any> => {
      const endPoint = `${this.apiBaseUrl}propeller/insertuploaddoc`;
      const formData = new FormData();
      formData.append('clientId', clientID);
      formData.append('recordObj', JSON.stringify({ recordObj: data }));

      console.log('Endpoint:', endPoint);

      return this.http.post(endPoint, formData, {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
        },
      }).pipe(
        catchError(err => {
          if (err.status === 401) {
            // Handle 401 Unauthorized error
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', "");
            localStorage.setItem('userName', "");
            localStorage.setItem('0', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('last_activity');
            sessionStorage.clear();
            window.location.href = '/#/auth';
            window.location.reload();
          }
          return throwError(err);
        })
      );
    }
    return uploadFileToPresignedUrl.pipe(
      switchMap(() => insertMetadataToBackend(data)),
      catchError(error => {
        console.error('Error during the process:', error);
        return throwError(() => new Error('An error occurred during the file upload process'));
      })
    );
  }

  //Document Type API's -----------------------------------------------------------------------------------------------
  getDocTypeEventView(eventId,obj:any): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('eventId', eventId);
    // if(idsObj){
      params = params.append('assetId', obj?.assetId);
      params = params.append('assetTypeId', obj?.assetTypeID);
    // }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/includedDocuments', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getTaskListEventView(eventId,obj:any): Observable<any[]> {
    let params = new HttpParams();
    if(eventId){
      params = params.append('eventId', eventId);
    }
    // if(idsObj){
      params = params.append('assetId', obj?.assetId);
      params = params.append('assetTypeId', obj?.assetTypeID);
    // }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/excludedTaskLists', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  assignPermissionsToEventTaskList(recordObj): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-event/setTaskListExclusions', recordObj, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  assignPermissionsToEventDocument(recordObj): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-event/excludeDocuments', recordObj, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  getDocTypeEventPermissionView(eventId,obj:any): Observable<any[]> {
    let params = new HttpParams();
      params = params.append('eventId', eventId);
    // if(idsObj){
      params = params.append('assetId', obj?.assetId);
      params = params.append('assetTypeId', obj?.assetTypeID);
    // }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/getFoldersList', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getDocTypeEventPermissionViewForAddEvent(obj:any): Observable<any[]> {
    let params = new HttpParams();

    // if(idsObj){
      params = params.append('assetId', obj?.assetId);
      params = params.append('assetTypeId', obj?.assetTypeID);
    // }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'asset-doc/listDirectoryTree', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }
  getDocTypeView(data, idsObj?: any): Observable<any[]> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    // params = params.append('wrecordId', data);
    // if(idsObj){
    //   params = params.append('assetId', idsObj?.assetId);
    //   params = params.append('assetTypeID', idsObj?.assetTypeID);
    // }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'document/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }

  getDocType(data): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('wrecordId', data.id);
    params = params.append('wit', data.wit);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'doctype/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }

  getDocTypeCategories(data): Observable<DocTypeCategory[]> {
    let params = new HttpParams();
    params = params.append('wrecordId', data.id);
    params = params.append('wit', data.wit);
    params = params.append('assetId', data.assetId);
    params = params.append('assetTypeID', data.assetTypeID);
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'doctype/listCat', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocTypeCategory[]>;
  }

  getLogBook(data, searchText?: string): Observable<DocTypeCategory[]> {
    let params = new HttpParams();
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchText) {
      params = params.append('LPN', searchText);
      params = params.append('LogDate', searchText);
      params = params.append('MSN', searchText);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'log/list', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocTypeCategory[]>;
  }

  findLogBook(data): Observable<DocTypeCategory[]> {
    let params = new HttpParams();
    params = params.append('id', data);

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'log/listLogById', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocTypeCategory[]>;
  }


  addLogPage(recordObj): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'log/insert', recordObj, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deletesbMod(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'sb-mod/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteComponentVirtualTour(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'component/deleteExternalLinks', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deletePropellerVirtualTour(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'propeller/deleteExternalLinks', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteLandingGearVirtualTour(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'landinggear/deleteExternalLinks', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteApuVirtualTour(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'apu/deleteExternalLinks', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteEngineVirtualTour(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'engine/deleteExternalLinks', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteVirtualTour(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('id', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'external-links/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteMpd(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'mpd/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteMipDetail(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'mip/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteMipHistory(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'mip/deleteHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }


  deleteRepairDemage(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'repair-damage/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  deleteAirWorthinessDirective(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'airworthiness-directive/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  uploadBulksbMod(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'sb-mod/bulkInsert', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  uploadBulkMpd(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'mpd/bulkInsert', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  uploadBulkComponentProfile(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'component/bulkInsertProfile',  data , {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  uploadBulkComponent(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'component/bulkInsert',  data , {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }


  uploadBulkRepairDamage(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'repair-damage/bulkInsert', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  uploadBulkMaintenanceTasks(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'asset-maintenance-mapping/validateBulkInsert', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  uploadBulkAirWorthinessDirective(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'airworthiness-directive/bulkInsert', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateSbMod(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'sb-mod/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateRepairDemage(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'repair-damage/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateVirtualTour(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'external-links/update',  data , {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateMpd(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'mpd/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateMipDetail(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'mip/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateMipHistory(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'mip/updateHistory', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateAirWorthinessDirective(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'airworthiness-directive/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  addSbMod(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'sb-mod/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addRepairDemage(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'repair-damage/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addVirtualTour(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'external-links/insert', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

    markDownloadErrorAsRead(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'asset-doc/updateSeenAt', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  addMpd(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'mpd/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addMipDetail(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'mip/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addBulkMipDetail(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'mip/bulkInsert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addMipHistory(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'mip/insertHistory/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addAirWorthinessDirective(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'airworthiness-directive/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  deleteStatusList(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'asset-maintenance-mapping/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateStatusList(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'asset-maintenance-mapping/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateEventItems(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'oil-item/update',  data , {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateEvent(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'oil-event/update',  data , {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  removeOilEventattachment(data): Observable<DocumentType | string> {
    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-attachment/delete', data, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  updateEventItemsComment(data): Observable<DocumentType | string> {
    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'oil-comment/update', {recordObj:data}, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addEventItemsComment(formData): Observable<DocumentType | string> {
    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-comment/insert', formData, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addEventUsersToEventById(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-event/assignUsers', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addEventItemsCommentAttachment(recordObj): Observable<DocumentType | string> {
    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-attachment/uploadMultiple', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteEventItemsComment(id): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-comment/delete', { commentId: id }, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addEventItems(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-item/insert', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addEvent(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-event/insert', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  reopenEvent(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'oil-event/reopen', recordObj, {
       headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addStatusList(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'asset-maintenance-mapping/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateAirWorthinessDirectivesTasks(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'compliance/update', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }
  updateCertificate(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'component/updateCertification', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  updateHistory(data): Observable<Propeller> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'component/updateHistory', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Propeller>;
  }

  addHistory(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'component/insertHistory', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addCertificate(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'component/insertCertification', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  addTypeLocalFolder(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'doctype/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addCategoryLocalFolder(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'doctype/insertCat', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addDocumentsFolder(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'document/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateDocumentsFolder(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'document/update', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addHeaderLocalFolder(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'doctype/insertHeader', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateHeaderLocalFolder(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'doctype/updateHeader', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  updateCatLocalFolder(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'doctype/updateCat', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  updateTypeLocalFolder(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'doctype/update', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteDocumentFolder(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'document/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteHeaderLocalFolder(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'doctype/deleteHeader', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteCategoryLocalFolder(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'all');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'doctype/deleteCat', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteTypeLocalFolder(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'doctype/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  addAirWorthinessDirectivesTasks(recordObj): Observable<DocumentType | string> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'compliance/insert', recordObj, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  //Airworthiness DataBase API's
  deleteTaskListCompliance(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'compliance/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteEventItem(id: number): Observable<DocumentType | string> {
  this.updateAccesToken();

  return this.http.delete(this.apiBaseUrl + 'oil-item/delete', {
    params: { id },
    headers: {
      "Authorization": localStorage.getItem("token")
        ? `Bearer ${localStorage.getItem("token")}`
        : ""
    }
  }).pipe(
    catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(() => err);
    })
  ) as Observable<DocumentType | string>;
}
  deleteEvent(id: number): Observable<any> {
  this.updateAccesToken();

  return this.http.delete(this.apiBaseUrl + 'oil-event/delete', {
    body: { event_id: id },  // ✅ Send in the body
    headers: {
      "Authorization": localStorage.getItem("token")
        ? `Bearer ${localStorage.getItem("token")}`
        : ""
    }
  }).pipe(
    catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err);
    })
  ) as Observable<any>;
}

  deleteCertificate(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'component/deleteCertification', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  getOilEventDashboardFilteredData(data?:any): Observable<Airdirective[]> {

    let params = new HttpParams();
    if(data){
      params = params.append('assetId', data?.assetId);
      params = params.append('assetTypeId', data?.assetTypeId);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/list', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getOilEventItemDataById(eventId:any,itemId:any): Observable<Airdirective[]> {

    let params = new HttpParams();
    params = params.append('eventId', eventId);
    params = params.append('id', itemId);
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-item/list', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getOilEventCategoryData(id?:any,obj?:any): Observable<Airdirective[]> {

    let params = new HttpParams();
    if(id){
      params = params.append('eventId', id);
    }
    if(obj){
       params = params.append('assetId', obj?.assetId);
       params = params.append('assetTypeId', obj?.assetTypeId);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/assetHierarchy', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getOilEventDashboardData(): Observable<Airdirective[]> {

    let params = new HttpParams();

    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-event/dashboard', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getPhysicalInpection(): Observable<Airdirective[]> {

    let params = new HttpParams();
    // params = params.append('wit', 'clientId');

    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'oil-physical-sections/list', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getCertificate(componentId,searchedText?:string): Observable<Airdirective[]> {

    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('componentId', componentId);
    if (searchedText) {
      params.append('certDate', searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'component/listCertification', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getTaskListCompliance(assetMaintenanceMappingId, searchedObj?: any): Observable<Airdirective[]> {

    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('assetMaintenanceMappingId', assetMaintenanceMappingId);
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params.append('totalCycles', searchedText);
      // params.append('totalTime', searchedText);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'compliance/listByAssetMaintenanceMapping', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }
  getStatusList(data, assetTypeId, assetId, searchedObj?: any): Observable<Airdirective[]> {

    let params = new HttpParams();
    params = params.append('assetId', assetId);
    params = params.append('assetTypeId', assetTypeId);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    if (searchedObj?.value && searchedObj?.searchedText) {
      // params = params.append('status', searchedText);
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
      // params = params.append('thresholdTac', searchedText);
    }
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'asset-maintenance-mapping/list', {
      params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<Airdirective[]>;
  }

  addDocType(recordObj): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'doctype/insertHeader', recordObj, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  addDocTypeCategory(recordObj): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'doctype/insertCat', recordObj, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  addDocTypeType(recordObj): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'doctype/insert?record', recordObj, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateDocType(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'doctype/updateHeader', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateDocTypeCategory(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'doctype/updateCat', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  updateDocTypeType(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'doctype/update?record=', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  //Role Delete
  deleteRole(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    // params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'role/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }


  // Delete User from Role
  deleteUserFromRole(payload: any): Observable<DocumentType | string> {


    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'user/detachRole', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }


  //Add User To Role
  addUserToRole(payload: any): Observable<DocumentType | string> {

    // params = params.append('wit', 'clientId');

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'user/attachRole', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }


  //Add Role
  addRole(payload: any): Observable<DocumentType | string> {

    // params = params.append('wit', 'clientId');

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'role/insert', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  // Update Role

  updateRole(data): Observable<DocumentType | string> {
    let params = new HttpParams();

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'role/update', data, {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }

  deleteDocType(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'doctype/deleteHeader', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteDocTypeCategory(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'all');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'doctype/deleteCat', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }
  deleteDocTypeType(id: number): Observable<DocumentType | string> {
    let params = new HttpParams();
    params = params.append('wit', 'clientId');
    params = params.append('wrecordId', id);

    this.updateAccesToken()
    return this.http.delete(this.apiBaseUrl + 'doctype/delete', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<DocumentType | string>;
  }


  // Api call to change password
  changePasswordApi(data): Observable<User> {
    const headers = new HttpHeaders({
      "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
    });

    return this.http.post<User>(this.apiBaseUrl + 'user/passResetAuthenticated', {
      old_password: data.old_password,
      password: data.password,
      userId: data.id,
      clientID: data.clientID
    }, {
      headers: headers,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }



  addFeedbackApi(data: any): Observable<any | string> {
    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'feedback/insert'


    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('POST', endPoint, data, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }



  updateFeedbackApi(data: any, id: number, feedbackId: string): Observable<any | string> {
    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'feedback/update?author_id=' + id;


    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('PUT', endPoint, { ...data, id: feedbackId }, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }





  getAllFeedbackApi(clientID: string, id: string): Observable<any | string> {
    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'feedback/list?clientID=' + clientID + '&id=' + id


    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    let params = new HttpParams()
    params.append("clientID", clientID)

    const req = new HttpRequest('GET', endPoint, {
      params: params,
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }

  getDashboardStats(clientID: string): Observable<any | string> {
    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'dashboard/listAssetCount?clientID=' + clientID


    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }



  getFeedbackByIdApi(clientID: string, id: number): Observable<any | string> {
    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'feedback/list'


    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    let params = new HttpParams()
    params.append("clientID", clientID)
    params.append("id", id)

    const req = new HttpRequest('GET', endPoint, {
      params,
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }



  postNewcommentApi(data: any): Observable<any | string> {
    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'comment/insert'


    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('POST', endPoint, data, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }



  getCommentsApi(feedbackID: string, clientID: string): Observable<any | string> {
    this.updateAccesToken()
    let endPoint: string = this.apiBaseUrl + 'comment/list?feedbackID=' + feedbackID;
    if (clientID) {
      endPoint = endPoint + '&clientID=' + clientID
    }

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }


  updateAccesToken(): void {
    let endPoint: string = this.apiBaseUrl + 'user/refreshToken';
    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('POST', endPoint, {
      refresh_token: localStorage.getItem('refresh')
    }, {
      headers: headers,
      reportProgress: true,
    });

    const res = this.http.request(req).pipe(
      catchError(err => {
        console.log(err)
        if(err?.error?.error === 'Invalid refresh token' || err?.error?.error === "Invalid signature"){
          this.openErrorSnackBar(
            err?.error?.error || 'Please contact support team',
            null
          );
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any>;

    res.subscribe(data => {
      if (data?.body?.access_token) {
        localStorage.setItem("token", data?.body?.access_token)
        localStorage.setItem("last_activity", data?.body?.access_token_expires.toString())
      }
    })
  }




  getWasabiStats(clientID: string): Observable<any | string> {
    this.updateAccesToken()
    let endPoint: string = this.apiBaseUrl + 'dashboard/listWasabiFolder';
    if (clientID) {
      endPoint = endPoint + '?clientID=' + clientID
    } else {
      endPoint = endPoint + '?clientID=all'
    }

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }





  getNewOTPToken(userName: string): Observable<any | string> {
    let client = JSON.parse(localStorage.getItem("client"))?.clientID
    let endPoint: string = this.apiBaseUrl + 'user/resendOTP?userName=' + userName + "&clientID=" + client;

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }



  // COMPONENTS PROFILE
  postNewComponentsProfileApi(data: any): Observable<any | string> {

    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'component/insertProfile'
    // const formData: FormData = new FormData();

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('POST', endPoint, data, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }


  putComponentsProfileApi(data: any): Observable<any | string> {

    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'component/updateProfile'
    // const formData: FormData = new FormData();

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('PUT', endPoint, data, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }

  getAssetsDocListApi(data:any): Observable<any | string> {
    let params = new HttpParams();

    //  params = params.append('assetTypeId', data?.assetTypeId);
    //  params = params.append('assetId', data?.assetId);
    params = params.append('eventId', data?.eventId);
    params = params.append('type', data?.type);
    let endPoint: string = this.apiBaseUrl + 'asset-doc/listFlatFiles';

    if(data?.filter){
       params = params.append(data?.filter?.name, data?.filter?.value);
    }
    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });
    params = params.append('sort', '-updatedAt');

    const req = new HttpRequest('GET', endPoint, {
      params,headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }
  getComponentsProfilesApi(searchedObj?:any): Observable<any | string> {
    let params = new HttpParams();
    let endPoint: string = this.apiBaseUrl + 'component/listProfile';

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
    }
    const req = new HttpRequest('GET', endPoint, {
      params, headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }

  getComponentRequiredActionByComponentIdApi(id: any): Observable<any | string> {
    let endPoint: string = this.apiBaseUrl + 'component/getRequiredActionList?componentId=' + id;

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }
  getComponentProfileByIdApi(id: string): Observable<any | string> {
    let endPoint: string = this.apiBaseUrl + 'component/listProfileById?id=' + id;

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }

  deleteComponentProfileByIdApi(id: string): Observable<any | string> {
    let endPoint: string = this.apiBaseUrl + 'component/deleteProfile?id=' + id;

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('DELETE', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }


  postNewComponentApi(data: any): Observable<any | string> {

    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'component/insert'
    // const formData: FormData = new FormData();

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('POST', endPoint, data, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }

  putComponentApi(data: any): Observable<any | string> {

    this.updateAccesToken()
    const endPoint: string = this.apiBaseUrl + 'component/update'
    // const formData: FormData = new FormData();

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('PUT', endPoint, data, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    ) as Observable<any | string>;
  }

  insertComponentSummary(data): Observable<ApuSummary> {
    // let params = new HttpParams();
    // params = params.append('recordObj', JSON.stringify(data));

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'component/insertSummary', { recordObj: data }, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<ApuSummary>;
  }

  getComponentApi(searchedObj?: any): Observable<any | string> {
    let endPoint: string = this.apiBaseUrl + 'component/list';
    let params = new HttpParams();
    params = params.append('sort', '-updatedAt');
    if (searchedObj?.value && searchedObj?.searchedText) {
      params = params.append(searchedObj?.value, searchedObj?.searchedText);
    }
    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      params, headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }
  getComponentHistoryByComponentId(data): Observable<any | string> {
    let params = new HttpParams();
    params = params.append('component_id', data.component_id);
    params = params.append('page', data.page);
    params = params.append('limit', data.limit);
    params = params.append('sort', '-updatedAt');
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'component/listHistory', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any[]>;
  }

  getComponentByIdApi(id: string): Observable<any | string> {
    let endPoint: string = this.apiBaseUrl + 'component/listById?id=' + id;

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('GET', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }

  deleteComponentByIdApi(id: string): Observable<any | string> {
    let endPoint: string = this.apiBaseUrl + 'component/delete?id=' + id;

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    });

    const req = new HttpRequest('DELETE', endPoint, {
      headers: headers,
      reportProgress: true,
    });

    return this.http.request(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("last_activity");;
          sessionStorage.clear();;
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    )
  }

  getComponentDocumentsByAssetSN(data: { clientId: string, recordId: number, assetId: string | number, filenameFilter?: string }): Observable<AssetDocument[]> {
    let params = new HttpParams();
    params = params.append('assetSN', data.clientId);
    params = params.append('assetId', data.assetId);
    params = params.append('recordID', data.recordId);
    if (data.filenameFilter) {
      params = params.append('filenameFilter', data.filenameFilter);
    }
    this.updateAccesToken()
    return this.http.get(this.apiBaseUrl + 'component/listdoc', {
      params: params, headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument[]>;
  }

  getComponentPresignedUrl(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}component/getUploadUrlDoc`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }
    const formData = new FormData();
    formData.append('clientId', clientID);
    formData.append('recordObj', JSON.stringify({ recordObj: data }));

    // const payload: any = {
    //   clientId: clientID,
    //   recordObj: data
    // };

    return this.http.post(endPoint, formData, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  addComponentDocAsync(data: any, presignedUrl: string, file: File): Observable<AssetDocument | string> {
    this.updateAccesToken()
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    if (!clientID) {
      return throwError(() => new Error('Client ID is not available'));
    }

    console.log('Presigned URL:', presignedUrl);

    // First API call: Upload file to the presigned URL
    const uploadFileToPresignedUrl = from(fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    })).pipe(
      catchError(error => {
        console.error('File upload failed:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );

    data['uploadedFileUrl'] = presignedUrl.split('?')[0];

    // Second API call: Insert metadata to the backend
    const insertMetadataToBackend = (data: any): Observable<any> => {
      const endPoint = `${this.apiBaseUrl}component/insertuploaddoc`;
      const formData = new FormData();
      formData.append('clientId', clientID);
      formData.append('recordObj', JSON.stringify({ recordObj: data }));

      console.log('Endpoint:', endPoint);

      return this.http.post(endPoint, formData, {
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
        },
      }).pipe(
        catchError(err => {
          if (err.status === 401) {
            // Handle 401 Unauthorized error
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', "");
            localStorage.setItem('userName', "");
            localStorage.setItem('0', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('last_activity');
            sessionStorage.clear();
            window.location.href = '/#/auth';
            window.location.reload();
          }
          return throwError(err);
        })
      );
    }
    return uploadFileToPresignedUrl.pipe(
      switchMap(() => insertMetadataToBackend(data)),
      catchError(error => {
        console.error('Error during the process:', error);
        return throwError(() => new Error('An error occurred during the file upload process'));
      })
    );
  }


  downloadAssetDocumentsDirectory(data: any, type: string): Observable<any> {
    let url: string;
    if (type === 'documentsDirectory') {
      url = `asset-doc/download?assetTypeId=${data.assetTypeId}&assetId=${data.assetId}&folderNodeId=[${data.folderNodeId}]`;
    }
    else if (type === 'assetDocumentsDirectories') {
      url = `asset-doc/download?assetTypeId=${data.assetTypeId}&assetId=${data.assetId}`;
    }
    else if (type === 'assetDocumentsDirectoriesWithAttachedAssets') {
      url = `asset-doc/download?assetTypeId=${data.assetTypeId}&assetId=${data.assetId}&downloadAll=true`;
    }
    this.updateAccesToken();
    return this.http.get(this.apiBaseUrl + url, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      },
      responseType: 'blob'
    }).pipe(map(response => {
      return response;
    }), catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
          if (err.error instanceof Blob) {
      return new Observable(observer => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            observer.error(errorJson); // <-- real backend message
          } catch {
            observer.error({ error: 'File download failed' });
          }
        };

        reader.readAsText(err.error);
      });
    }
      return throwError(err);
    })) as Observable<any>;
  }

    getDownloads(): Observable<any> {
    // this.updateAccesToken();
    return this.http.get(this.apiBaseUrl + 'asset-doc/getUserJobs', {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(map(response => {
      return response;
    }), catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err);
    })) as Observable<any>;
  }

  deleteComponentDoc(data): Observable<AssetDocument | string> {
    let payload: any = {
      "recordId": data.recordId,
      "parentId": data.parentId
    };

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'component/deletedoc', payload, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<AssetDocument | string>;
  }


  goBack(): void {
    this.location.back();
  }
  goForward(): void {
    this.location.forward();
  }

  assetTabRemoveStorage() {
    localStorage.removeItem('subSelectedTab');
    localStorage.removeItem('assetsActiveTab');
  }
  openBulkErrorSnackBarForTaskList(messages: any, action: string = '') {
    if (messages?.length > 0) {
      if (!Swal.isVisible()) {
        // Generate the error table dynamically
        let errorTable = `
          <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
            <thead>
              <tr style="background-color: #f2f2f2; text-align: left;">
                <th style="padding: 8px; border-bottom: 1px solid #ddd;width: 5px;">Row #</th>
                <th style="padding: 8px; border-bottom: 1px solid #ddd;width: 60px;">Error</th>
                <th style="padding: 8px; border-bottom: 1px solid #ddd;width: 60px;">Record Details</th>
              </tr>
            </thead>
            <tbody>
              ${messages.map(error => `
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: left;">${error.rowNumber}</td>
  <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: left; word-wrap: break-word;">
    ${error.errors.join('<br>')}
  </td>
  <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: left; word-wrap: break-word;">
    ${error?.record?.maintenanceType ? `<strong>Maintenance Type:</strong> ${error.record.maintenanceType} <br>` : ""}
        ${error?.record?.oemTaskNumber ? `<strong>OEM Task Number:</strong> ${error.record.oemTaskNumber} <br>` : ""}
        ${error?.record?.status ? `<strong>Status:</strong> ${error.record.status} <br>` : ""}
        ${error?.record?.thresholdDate ? `<strong>Threshold Date:</strong> ${error.record.thresholdDate} <br>` : ""}
        ${error?.record?.thresholdTac ? `<strong>Threshold Tac:</strong> ${error.record.thresholdTac}` : ""}
  </td>
                </tr>`).join('')}
            </tbody>
          </table>
        `;

        Swal.fire({
          icon: "error",
          title: "Upload Errors",
          html: errorTable, // Injecting the table
          width: "800px", // Make it wide for better readability
          backdrop: false,
          didOpen: () => {
            document.body.insertAdjacentHTML(
              "beforeend",
              '<div id="customSwalBackdrop" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.4); z-index: 1040;"></div>'
            );
          },
          willClose: () => {
            document.getElementById("customSwalBackdrop")?.remove();
          },
          confirmButtonText: 'OK'
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.isConfirmed) {
            Swal.close();
          }
        });
      }
    }
    else {
      this.openErrorSnackBar('Please contact support team')
    }
  }
  openBulkErrorSnackBar(messages: any, action: string = '') {
    if (messages?.length > 0) {
      if (!Swal.isVisible()) {
        // Generate the error table dynamically
        let errorTable = `
          <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
            <thead>
              <tr style="background-color: #f2f2f2; text-align: left;">
                <th style="padding: 8px; border-bottom: 1px solid #ddd;width: 5px;">Row #</th>
                <th style="padding: 8px; border-bottom: 1px solid #ddd;width: 60px;">Error</th>
                <th style="padding: 8px; border-bottom: 1px solid #ddd;width: 60px;">Record Details</th>
              </tr>
            </thead>
            <tbody>
              ${messages.map(error => `
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: left;">${error.rowNumber}</td>
  <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: left; word-wrap: break-word;">
    ${error.errors.join('<br>')}
  </td>
  <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: left; word-wrap: break-word;">
    ${error?.record?.model ? `<strong>Model:</strong> ${error.record.model} <br>` : ""}
        ${error?.record?.type ? `<strong>Type:</strong> ${error.record.type} <br>` : ""}
        ${error?.record?.faaAdNum ? `<strong>FAA AD #:</strong> ${error.record.faaAdNum} <br>` : ""}
        ${error?.record?.description ? `<strong>Description:</strong> ${error.record.description} <br>` : ""}
        ${error?.record?.remarks ? `<strong>Remarks:</strong> ${error.record.remarks}` : ""}
  </td>
                </tr>`).join('')}
            </tbody>
          </table>
        `;

        Swal.fire({
          icon: "error",
          title: "Upload Errors",
          html: errorTable, // Injecting the table
          width: "800px", // Make it wide for better readability
          backdrop: false,
          didOpen: () => {
            document.body.insertAdjacentHTML(
              "beforeend",
              '<div id="customSwalBackdrop" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.4); z-index: 1040;"></div>'
            );
          },
          willClose: () => {
            document.getElementById("customSwalBackdrop")?.remove();
          },
          confirmButtonText: 'OK'
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.isConfirmed) {
            Swal.close();
          }
        });
      }
    }
    else {
      this.openErrorSnackBar('Please contact support team')
    }
  }

  openErrorSnackBar(message: string, action: string = '') {
    if (!Swal.isVisible()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: message,
        backdrop: false,
        didOpen: () => {
          document.body.insertAdjacentHTML(
            "beforeend",
            '<div id="customSwalBackdrop" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.4); z-index: 1040;"></div>'
          );
        },
        willClose: () => {
          document.getElementById("customSwalBackdrop")?.remove();
        },
        confirmButtonText: 'OK'
        // footer: '<a href="#">Why do I have this issue?</a>'
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.isConfirmed) {
          Swal.close();
        }
      });
    }
  }
  public openSnackBar(message: string, action: string = '') {
    if (!Swal.isVisible()) {
      Swal.fire({
        title: "Done!",
        text: message,
        backdrop: false,
        didOpen: () => {
          document.body.insertAdjacentHTML(
            "beforeend",
            '<div id="customSwalBackdrop" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.4); z-index: 1040;"></div>'
          );
        },
        willClose: () => {
          document.getElementById("customSwalBackdrop")?.remove();
        },
        icon: "success",
        timer: 3000,
        timerProgressBar: true,
        showCancelButton: true,  // ✅ Add a cancel button
        showConfirmButton: false,  // ✅ Add a cancel button
        cancelButtonText: 'Close'
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss) {
          Swal.close();
        }
      });
    }
  }
  // onNumericInput(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   input.value = input.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
  // }
  onNumericInput(event: Event, formControl: AbstractControl | null): void {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^0-9]/g, ''); // Keep digits only
    input.value = sanitized;

    if (formControl) {
      formControl?.setValue(sanitized, { emitEvent: false });
    }
  }


  // onTimeInput(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   // Allow only numeric values with up to 2 decimal places
  //   input.value = input.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'); // Remove invalid characters and extra decimals
  //   const parts = input.value.split('.');
  //   if (parts[1] && parts[1].length > 2) {
  //     input.value = `${parts[0]}.${parts[1].substring(0, 2)}`; // Restrict to 2 decimal places
  //   }
  // }
  onTimeInput(event: Event, formControl?: AbstractControl | null): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove all non-numeric characters except one decimal point
    value = value.replace(/[^0-9.]/g, '');

    const firstDecimalIndex = value.indexOf('.');
    if (firstDecimalIndex !== -1) {
      const beforeDecimal = value.substring(0, firstDecimalIndex);
      const afterDecimal = value.substring(firstDecimalIndex + 1).replace(/\./g, '');
      value = `${beforeDecimal}.${afterDecimal}`;
    }

    // Restrict to two decimal places
    const parts = value.split('.');
    if (parts.length > 1 && parts[1].length > 2) {
      value = `${parts[0]}.${parts[1].substring(0, 2)}`;
    }

    // Update input value
    input.value = value;

    // Update the form control value explicitly
    if (formControl) {
      formControl?.setValue(value, { emitEvent: false });
    }
  }


   public async ViewDetailData(columnData:any,args?: any,pageName?:any,modelWidth?:string,addItemsData?:any): Promise<void> {
    console.log(addItemsData)
        const modal = await this.modalController.create({
          component: ViewTableRowDetailComponent,
          cssClass: 'view-generic-modal',
          componentProps: { columnData: columnData , data:args,PageName:pageName,addItemsData:addItemsData || null },
        });
        await modal.present();
        const modalElement = modal;
        if (modalElement) {
          modalElement.style.setProperty('--height', modelWidth || '350px');
        }
        const backdropElement = document.querySelector('ion-backdrop');
        if (backdropElement) {
          backdropElement.style.setProperty('backdrop-filter', 'blur(10px)');
          backdropElement.style.setProperty('background-color', 'rgba(0, 0, 0, 0.4)');  // Optional dark background shade
        }
        await modal.onDidDismiss().then(async (result) => {

        });
      }
   public async ViewRequiredActionDetailData(columnData:any,args?: any,pageName?:any,modelWidth?:string): Promise<void> {
        const modal = await this.modalController.create({
          component: ViewTableRequiredActionComponent,
          cssClass: 'view-generic-modal',
          componentProps: { columnData: columnData , data:args,PageName:pageName },
        });
        await modal.present();
        const modalElement = document.querySelector('ion-modal');
        if (modalElement) {
          modalElement.style.setProperty('--height', args?.length > 1 ? '700px' : modelWidth || '350px');
        }
        const backdropElement = document.querySelector('ion-backdrop');
        if (backdropElement) {
          backdropElement.style.setProperty('backdrop-filter', 'blur(10px)');
          backdropElement.style.setProperty('background-color', 'rgba(0, 0, 0, 0.4)');  // Optional dark background shade
        }
        await modal.onDidDismiss().then(async (result) => {

        });
      }

      toTwoDecimal(value: any): string {
        if(!value) return null;
        const num = Number(value);
        return isNaN(num) ? null : num.toFixed(2);
      }

      normalizeKey(key) {
  return key.replace(/[\r\n↵]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
}

    getRowValue(row, targetHeader) {
  const normalizedTarget = this.normalizeKey(targetHeader);

  for (let key of Object.keys(row)) {
    if (this.normalizeKey(key) === normalizedTarget) {
      let value = row[key];

      if (value !== null && value !== undefined) {
        // Convert value to string and remove line breaks and extra spaces
        return String(value)
          .replace(/[\n\r]/g, '') // remove line breaks
          .trim();                // remove leading/trailing whitespace
      }

      return value;
    }
    }
    return null;
  }

  excelToJSDate(input: any): string {
    if (!input) return null;

    const inputStr = input?.toString().trim().replace(/\s+/g, '');

    let jsDate: Date;

    // Case 1: Handle Excel serial number (e.g., 43631)
    if (!isNaN(Number(inputStr)) && Number(inputStr) > 30000 && Number(inputStr) < 60000) {
      const excelEpoch = new Date(1899, 11, 30); // Excel epoch start
      jsDate = new Date(excelEpoch.getTime() + Number(inputStr) * 86400000);
    }
    // Case 2: Handle date strings with various separators
    else if (typeof inputStr === 'string') {
      const standardized = inputStr.replace(/[\/]/g, '-');
      const parts = standardized.split('-').map(Number);

      if (parts.length === 3) {
        let year, month, day;

        if (parts[0] > 31) {
          // Format: YYYY-MM-DD or YYYY-DD-MM
          year = parts[0];
          if (parts[1] > 12) {
            day = parts[1];
            month = parts[2];
          } else {
            month = parts[1];
            day = parts[2];
          }
        } else if (parts[2] > 31) {
          // Format: DD-MM-YYYY
          day = parts[0];
          month = parts[1];
          year = parts[2];
        } else {
          // Ambiguous: Assume DD-MM-YYYY
          day = parts[0];
          month = parts[1];
          year = parts[2];
        }

        jsDate = new Date(year, month - 1, day);
      } else {
        // Fallback to native parsing
        jsDate = new Date(inputStr);
      }
    }
  // Final check
  if (!jsDate || isNaN(jsDate.getTime())) return null;

  return this.datePipe?.transform(jsDate, 'yyyy-MM-dd HH:mm:ss') || null;
}

dateFormatCorrectForDatePicker(value:any){
return value && value?.toString() !== '0000-00-00' ? parse(value, 'yyyy-MM-dd', new Date()) : null
}
restrictSpecialCharactersInput(event: any, control: AbstractControl): void {
  if (!event?.target || !control) return;

  const inputValue = event.target.value;

  // Regex to remove spaces + restricted characters
  // Characters: < > : " / \ | ? *
  const sanitizedValue = inputValue.replace(
    /[<>:"\/\\|?*]/g,
    ''
  );

  // Set the sanitized value back to the control without triggering valueChanges
  control.setValue(sanitizedValue, { emitEvent: false });
}


updateOilEventDocumentStatus(data): Observable<any> {

    this.updateAccesToken()
    return this.http.put(this.apiBaseUrl + 'asset-doc/oilDocApprovalUpdate', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any>;
  }
updateOilEventTaskListStatus(data): Observable<any> {

    this.updateAccesToken()
    return this.http.post(this.apiBaseUrl + 'asset-maintenance-mapping/taskListApproval', data, {
      headers: {
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
      }
    }).pipe(catchError(err => {
      if (err.status === 401) {
        // Handle 401 Unauthorized error
        localStorage.removeItem('user');
        localStorage.setItem('userFullName', "");
        localStorage.setItem('userName', "");
        localStorage.setItem('0', "");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        localStorage.removeItem("last_activity");
        sessionStorage.clear();
        window.location.href = '/#/auth';
        window.location.reload();
      }
      return throwError(err)
    })) as Observable<any>;
  }




  getEventComments(data: any): Observable<any> {
    const endPoint = `${this.apiBaseUrl}oil-comment/list?itemId=${data.itemId}`;
    const clientID = JSON.parse(localStorage.getItem('client'))?.clientID;

    return this.http.get(endPoint, {
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
      },
      reportProgress: true,
    }).pipe(
      catchError(err => {
        if (err.status === 401) {
          // Handle 401 Unauthorized error
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', "");
          localStorage.setItem('userName', "");
          localStorage.setItem('0', "");
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
          window.location.reload();
        }
        return throwError(err);
      })
    );
  }

  private activeModal: HTMLIonModalElement | null = null;
  async reportViewer(dd: any,exportType?:string,assetName?:string,msn?:string,reportType?:any){
      if (this.activeModal) {
        return  // OR return; if you don't want to reopen
      }
      let obj:any={
        file:dd
      }
      if(exportType){
        obj['exportType'] = exportType
      }
      if(assetName){
        obj['assetName'] = assetName
      }
      if(msn){
        obj['msn'] = msn
      }
      if(reportType){
        obj['reportType'] = reportType
      }
    const modal = await this.modalController.create({
      component: ReportViewerComponent,
      componentProps: obj,//Fetch event ID from query param and pass it here
      cssClass: 'document-viewer',
      backdropDismiss: false,
    })
    this.activeModal = modal;
    modal.onDidDismiss().then(() => {
        this.activeModal = null;
   // this.close();
        })
    await modal.present();
  }


}
